var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGitterLightSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 0.12915C0.447693 0.12915 0 0.576874 0 1.12915V12.1292C0 12.6814 0.447693 13.1292 1 13.1292C1.55231 13.1292 2 12.6814 2 12.1292V1.12915C2 0.576874 1.55231 0.12915 1 0.12915ZM5 4.12915C4.44775 4.12915 4 4.57687 4 5.12915V16.1292C4 16.6814 4.44775 17.1292 5 17.1292C5.55225 17.1292 6 16.6814 6 16.1292V5.12915C6 4.57687 5.55225 4.12915 5 4.12915ZM8 5.12915C8 4.57687 8.44775 4.12915 9 4.12915C9.55225 4.12915 10 4.57687 10 5.12915V16.1292C10 16.6814 9.55225 17.1292 9 17.1292C8.44775 17.1292 8 16.6814 8 16.1292V5.12915ZM13 4.12915C12.4478 4.12915 12 4.57687 12 5.12915V12.1292C12 12.6814 12.4478 13.1292 13 13.1292C13.5522 13.1292 14 12.6814 14 12.1292V5.12915C14 4.57687 13.5522 4.12915 13 4.12915Z",
    fill: "#1847CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitterLightSmall);
export default __webpack_public_path__ + "static/media/gitter-light-small.9dee4e527534344495a1a1341339242f.svg";
export { ForwardRef as ReactComponent };